module.exports = __webpack_public_path__ + "app-download-qr-3480c4.webp";